<template>
  <div class="panel mt-20">
    <file-button
      class="mobile-hide"
      obj="customer_shipto_relation"
      style="float: right"
      :filter="{}"
      :importButton="userInfo.id == 1"
      :exportButton="false"
      :downTemplate="false"
      @importCallback="requestCustomerContactList"
    ></file-button>

    <el-table v-if="!isMobile()" :data="contacts" stripe key="contacts">
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column
        prop="mobile"
        label="电话"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="duty"
        label="职务"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="email"
        label="邮箱"
        align="center"
      ></el-table-column>
      <el-table-column prop="customer.name" label="客户名称">
        <template slot-scope="scope">
          <customer-link
            class="mr-5"
            :customer="scope.row.customer"
          ></customer-link>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="item in contacts" :key="item.id">
        <div>
          <div>
            {{ item.name }}
            <span v-if="item.duty && item.duty.length > 0"
              >({{ item.duty }})</span
            >
          </div>
          <div
            style="margin-top: 5px"
            v-if="item.mobile && item.mobile.length > 0"
          >
            <a :href="'tel:' + item.mobile">{{ item.mobile }}</a>
          </div>
          <div v-if="item.email && item.email.length > 0">
            <a :href="'mailto:' + item.email">{{ item.email }}</a>
          </div>
        </div>
      </li>
      <p v-if="contacts.length == 0" class="mt-20">暂无数据</p>
    </ul>
  </div>
</template>

<script>
import { customerContactList } from '../../service/getData'
import { isMobile } from '@/util/index'
import store from '@/store/store'

export default {
  props: {
    customerID: {
      type: Number,
    },
  },
  data() {
    return {
      userInfo: store.getters.userInfo,
      isMobile,
      contacts: [],
    }
  },
  watch: {
    customerID: function () {
      if (this.customerID) {
        this.requestCustomerContactList()
      }
    },
  },
  created() {
    this.requestCustomerContactList()
  },
  methods: {
    async requestCustomerContactList() {
      let res = await customerContactList({
        customer_id: this.customerID,
        is_shipto_list: true,
      })
      this.contacts = res.data.list
    },
  },
}
</script>